// UserService.js
import { reactive } from 'vue';
import router from '../../router'; // Předpokládejme, že vaše routerové nastavení je v souboru router.js

// Vytvoření služby
const userService = reactive({
    userData: {
        email: '',
        displayName: '',
        uid: ''
    },
    
    loadUserData() {
        const email = localStorage.getItem("user_email");
        const displayName = localStorage.getItem("user_displayName");
        const uid = localStorage.getItem("user_uid");
        if (email && displayName && uid) {
            this.userData = {
                email: email,
                displayName: displayName,
                uid: uid,
            };
        }
    },

    getUserData() {
        return this.userData;
    },

    checkUserLogin() {
        const email = localStorage.getItem("user_email");
        const displayName = localStorage.getItem("user_displayName");
        const uid = localStorage.getItem("user_uid");
        if (email && displayName && uid) {
            this.userData = {
                email: email,
                displayName: displayName,
                uid: uid,
            };
            return true; // Pokud jsou data nalezena, vrátí true
        } else {
            router.push('/prihlaseni'); // Pokud data nejsou nalezena, přesměrujeme na /prihlaseni
            return false;
        }
    },

    // Nová metoda pro validaci uid
    validateUid() {
        const uid = localStorage.getItem("user_uid");
        return new Promise((resolve) => {
            if (uid) {
                resolve(true); // Uid je platný
            } else {
                resolve(false); // Uid není platný
            }
        });
    }
});

export default userService;
